"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FileText, Lock, Pencil, Award } from "lucide-react";
export default function AvailableWritingTools() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const tools = [{
    icon: FileText,
    title: "NCOER Bullet Builder",
    description: "Generate regulation-compliant NCOER bullets aligned with DA PAM 623-3 standards in seconds.",
    status: "live",
    link: "https://chatgpt.com/g/g-693ae182b4dc8191a8968fc05dd3cf67-ncoer-bullet-builder"
  }, {
    icon: Award,
    title: "Award Bullet & Citation Builder",
    description: "Create professional Army award bullets and citations that meet all writing standards quickly and accurately.",
    status: "live",
    link: "https://chatgpt.com/g/g-693c16f74a1481919cd40cb42b4541bc-army-award-bullet-citation-builder"
  }, {
    icon: Pencil,
    title: "Counseling Statement Builder",
    description: "Produce clear, professional counseling statements with proper formatting and Army regulation compliance.",
    status: "live",
    link: "https://chatgpt.com/g/g-693c850a7eb881919f4c2a5e23dfdc74-army-counseling-statement-builder"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="available-writing-tools" className="bg-background py-16 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground mb-4">
            Available Writing Tools
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Select from our suite of AI-powered tools designed specifically for Army documentation needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tools.map((tool, i) => {
          const Icon = tool.icon;
          const ref = refs[i];
          const isVisible = visibilities[i];
          return <div key={i} data-index={i} ref={ref} className="transition-all duration-200 ease-out" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(10px)",
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] border border-border shadow-soft">
                  <CardHeader>
                    <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-md bg-primary/10 text-primary">
                      <Icon className="size-6" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {tool.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-muted-foreground text-sm leading-relaxed">
                      {tool.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="mt-auto">
                    {tool.status === "live" ? <Button asChild className="w-full bg-accent text-foreground-accent hover:bg-accent-hover hover:scale-[1.02] active:bg-accent-active transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-xs">
                        <Link to={tool.link}>
                          Launch Tool
                        </Link>
                      </Button> : <Button disabled className="w-full bg-muted text-muted-foreground cursor-not-allowed opacity-60">
                        <Lock className="size-4 mr-2" />
                        Coming Soon
                      </Button>}
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}